import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell, Button } from "@nextui-org/react";
import { AfDataType } from "utils/TableColumnData";

export type AfTableProps = Partial<{
  validationSchema: any;
  tableData: any[];
  setTableData: Function;
  zone: any;
  isDox: boolean;
  tableColumnData: any[];
}>;

const RateAddEditSingleTable: React.FC<AfTableProps> = ({
  validationSchema,
  tableData = [],
  setTableData,
  isDox = false,
  zone = "zone a",
  tableColumnData =[],
}) => {

  const navigate = useNavigate();

  return (
    <div className="p-5 ">
      <div className={`py-1 pr-1 rounded-md flex overflow-auto ${isDox ? "bg-black-900" : "bg-orange-600"}`}>
        <div className={`text-center px-2 w-20 min-w-20 `}>
          {isDox ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="#fff"
              className="size-10 mx-auto"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff" className="size-10 mx-auto">
              <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
              <path
                fillRule="evenodd"
                d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087Zm6.163 3.75A.75.75 0 0 1 10 12h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75Z"
                clipRule="evenodd"
              />
            </svg>
          )}
          <div className="font-semibold text-sm text-white border-b-2">
            {isDox ? <p className="text-white">DOX</p> : <p className="whitespace-nowrap">NO-DOX</p>}
          </div>

          <p className="text-white">Zone</p>
          <span className="text-white font-bold text-xl">{zone == "zone a" ? "A" : "B"}</span>
        </div>

        <table className="w-full text-sm text-left text-gray-500 border-r border-y bg-white">
          <thead className="text-xs text-gray-700 bg-gray-50 ">
            <tr>
              <th>
                <Button
                  className="mx-1 bg-gradient-to-tr from-green-500 to-green-300 text-white shadow-lg w-8 h-8 px-0 min-w-0"
                  radius="full"
                  onPress={() => {
                    setTableData((prevTableData) => [
                      ...prevTableData,
                      tableColumnData.reduce((row, column) => {
                        row[column.key] = "";
                        return row;
                      }, {}),
                    ]);
                  }}
                >
                  +
                </Button>
              </th>
              {tableColumnData.map((column) => (
                <th className="px-2 py-2 border-l border-b" key={column.key + "-head"}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((tdd, ti) => {
              return (
                <tr key={"-tr-" + ti}>
                  <td>
                    <Button
                      className="mx-1 bg-gradient-to-tr from-red-500 to-orange-600 text-white shadow-lg w-6 h-6 px-0 min-w-0"
                      radius="sm"
                      onPress={() => {
                        setTableData((prevTableData) => prevTableData.filter((_, index) => index !== ti));
                      }}
                    >
                      -
                    </Button>
                  </td>
                  {tableColumnData.map((column, i) => (
                    <td key={column.key + "-val-" + ti} className="px-1 border-l">
                      <input
                        type="text"
                        value={tdd[column.key] == null || tdd[column.key] == undefined ? "" : tdd[column.key]}
                        aria-label={column.label}
                        placeholder={column.label}
                        onChange={(e) => {
                          const updatedTableData = [...tableData];
                          updatedTableData[ti] = { ...updatedTableData[ti], [column.key]: e.target.value };
                          setTableData(updatedTableData);
                        }}
                        className=" bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-1 min-w-12"
                      />
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RateAddEditSingleTable;
